/* eslint-disable react-hooks/exhaustive-deps */
import React, { FC, useEffect, useRef, useState } from "react";
import {Dropdown, Input, InputProps, MenuProps} from "antd";
import Typography from "components/OnahTypography";
import classNames from "classnames";
import OnahInputError from "components/OnahInputError";
import parsePhoneNumber, { CountryCode } from 'libphonenumber-js';
import {useOnahSelector } from "store/hooks";
import { getCountryFlag } from "helper";
import OnahLabel from "components/OnahLabel";

interface Props extends InputProps {
  label?: string;
  wrapperClassName?: string;
  labelClassName?: string;
  buttonClassName?: string;
  error?: string;
  onPhoneChange?: (e?:  React.ChangeEvent<HTMLInputElement>) => void;
}

const OnahPhoneInput: FC<Props> = ({label, name, className, wrapperClassName, labelClassName, buttonClassName, error, type = 'input', suffix, value, ...props}) => {
  const [phone, setPhone] = useState('');
  const input = useRef<HTMLInputElement>(null);

  const {countries,} = useOnahSelector(state => state.common);
  const [selectedCountry, setSelectedCountry] = useState('');
  const [phoneCode, setPhoneCode] = useState('');
  const [focused, setFocused] = useState(false);

  useEffect(() => {
    if(!countries.length) {
      // dispatch(getCountries());
    }
  }, []);

  useEffect(() => {
    if(value) {
      const phoneNumber = parsePhoneNumber(value.toString());
      if(phoneNumber) {
        setPhone(phoneNumber.nationalNumber);
        setDefaultCountry(phoneNumber.country?.toString() ?? 'NG');
        setPhoneCode('+' + phoneNumber.countryCallingCode.toString())
      } else {
        setDefaultCountry('NG');
        setPhoneCode('+234')
      }
    } else {
      setDefaultCountry('NG');
      setPhoneCode('+234')
    }
  }, [])

const items: MenuProps['items'] = countries.map(country => ({
  key: country.iso,
  label: <div className="flex items-center">
      <div className='w-[24px] h-auto mr-2'><img src={getCountryFlag(country.iso)} alt={country.iso}/></div>
      <Typography>{country.dialCode}</Typography>
  </div>,
}));

const setDefaultCountry = (country: string, triggerOnChange = false) => {
  setSelectedCountry(country);
  // const foundCountry = countries.find(cnt => cnt.iso.toLowerCase() === country.toLowerCase());
  // if(foundCountry) {
  //   setPhoneCode(foundCountry?.dialCode);
  //   if(triggerOnChange) {
  //     setPhone('');
  //     var ev2 = new Event('input', { bubbles: true});
  //     input.current?.onchange && input.current?.onchange(ev2)
  //   }
  // }
};

const onChange = (e:  React.ChangeEvent<HTMLInputElement>) => {
  const phoneNumber = parsePhoneNumber(e.target.value, selectedCountry as CountryCode)
  if(e.target.value) {
    e.target.value = phoneNumber?.number.toString() ?? e.target.value;
  }
  if(name) {
    e.target.name = name ?? '';
  }
  if(props.onChange) {
    props.onChange(e);
  }
  const replaceValue =  phoneCode;
  setPhone(e.target.value.replace(replaceValue, ''));
}


  return (
    <div className={wrapperClassName}>
      <OnahLabel label={label} />
      <Input
        {...props as any}
        onFocus={(e) => {
          props?.onFocus && props.onFocus(e as any);
          setFocused(true)
        }} 
        onBlur={(e) => {
          props?.onBlur && props.onBlur(e as any);
          setFocused(false)
        }} 
        ref={input}
        name={name}
        inputMode="tel"
        value={phone}
        placeholder={props.placeholder || label}
        onChange={onChange}
        className={classNames(
          className,
          'py-[14px] max-2xl:py-[12px] max-2xl:h-[48px] h-[50px] text-lg max-2xl:text-base',
          'px-3 rounded outline-none focus:!outline-none !border-0 !font-sans',
          'focus:border-primary-ctaStroke hover:!border-primary-ctaStroke focus:!border hover:!border rounded-lg',
          ' [&>input]:!font-sans',
          '[&>input]:placeholder:text-gray-placeholder [&>input]:placeholder:font-medium [&>input]:font-sans',
          'bg-gray-restingField [&>input]:bg-gray-restingField font-semibold',
          error ? '!border-error-700 focus:!border-error-700 !border' : '',
          )}
          prefix={
            <Dropdown
              disabled={true} 
              trigger={["click"]} 
              
              menu={{ items, style: {maxHeight: '50vh', overflow: 'auto'}, 
              onClick(item){
              setDefaultCountry(item.key, true)
              },}} 
              className={classNames(className)}>
              <button className={classNames(buttonClassName, 'justify-center flex items-center mr-2')} onClick={(e) => e.preventDefault()}>
                <span className={classNames(
                  '!font-sans text-lg max-2xl:text-base font-medium',
                    focused ? 'text-black' : '!text-gray-placeholder',
                    phone ? '!text-black !font-semibold' : '',
                  )}>{phoneCode}</span>
              </button>
          </Dropdown>
          }
      />
      <OnahInputError error={error} showError={!!error}/>
    </div>
  );
};

export default OnahPhoneInput;

